// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ez_n","icon":"styles_icon__cu0T6"};